import ListPatient from '@/views/patient/list/ListPatient.vue';
import HomeDetail from '@/views/patient/HomeDetail.vue';
import { authAdminDoctorClinic } from '@/common/constants/auth';
import Health from '@/views/patient/show/health/Health.vue';
import SubPatient from '@/components/Patient/SubPatient.vue';

export default [
  {
    path: '/patients',
    name: 'patients',
    component: ListPatient,
    meta: authAdminDoctorClinic,
  },
  {
    path: '/patients/health/:id',
    name: 'patients.health',
    component: Health,
    meta: authAdminDoctorClinic,
  },
  {
    path: '/patients/detail/:id',
    name: 'patients.detail',
    component: HomeDetail,
    meta: authAdminDoctorClinic,
  },
  {
    path: '/patients/sub/:id',
    name: 'patients.sub.detail',
    component: SubPatient,
    props: true,
    meta: authAdminDoctorClinic,
  },
];
